import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

    @Output()
    public searchQueryChanged : EventEmitter<any> = new EventEmitter();

    constructor() {}

}
